var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1852 0.833374H1.80745C0.992633 0.833374 0.333374 1.50004 0.333374 2.31486L0.340781 12.6852C0.340781 13.5 1.00004 14.1667 1.81486 14.1667H9.22226L13.6667 9.72226V2.31486C13.6667 1.50004 13 0.833374 12.1852 0.833374ZM3.29634 4.53708H10.7037V6.01856H3.29634V4.53708ZM7.00004 8.98152H3.29634V7.50004H7.00004V8.98152ZM8.48152 13.0556V8.98152H12.5556L8.48152 13.0556Z",
    fill: "#CF0A2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.3f9f48300bf51bc13a35b17bd36def60.svg";
export { ForwardRef as ReactComponent };